//SESSION
export const RECEIVE_SESSION_USER = 'RECEIVE_SESSION_USER';

//CORPORATION
export const CLEAR_CORP_STATE = 'CLEAR_CORP_STATE';

export const REQUEST_CORP = 'REQUEST_CORP';
export const RECEIVE_CORP = 'RECEIVE_CORP';
export const RECEIVE_CORP_ERROR = 'RECEIVE_CORP_ERROR';

export const REQUEST_CORP_LIST = 'REQUEST_CORP_LIST';
export const RECEIVE_CORP_LIST = 'RECEIVE_CORP_LIST';
export const RECEIVE_CORP_LIST_ERROR = 'RECEIVE_CORP_LIST_ERROR';

export const SUBMIT_EDIT_CORP = 'SUBMIT_EDIT_CORP';
export const RESOLVE_EDIT_CORP = 'RESOLVE_EDIT_CORP';
export const RESOLVE_EDIT_CORP_ERROR = 'RESOLVE_EDIT_CORP_ERROR';

export const SUBMIT_CREATE_CORP = 'SUBMIT_CREATE_CORP';
export const RESOLVE_CREATE_CORP = 'RESOLVE_CREATE_CORP';
export const RESOLVE_CREATE_CORP_ERROR = 'RESOLVE_CREATE_CORP_ERROR';

export const REQUEST_AUTO_COMPLETE_CORP_LIST = 'REQUEST_AUTO_COMPLETE_CORP_LIST';
export const RECEIVE_AUTO_COMPLETE_CORP_LIST = 'RECEIVE_AUTO_COMPLETE_CORP_LIST';
export const RECEIVE_AUTO_COMPLETE_CORP_LIST_ERROR = 'RECEIVE_AUTO_COMPLETE_CORP_LIST_ERROR';

export const SUBMIT_LINK_CORP = 'SUBMIT_LINK_CORP';
export const RESOLVE_LINK_CORP = 'RESOLVE_LINK_CORP';
export const RESOLVE_LINK_CORP_ERROR = 'RESOLVE_LINK_CORP_ERROR';

export const SUBMIT_UNLINK_CORP = 'SUBMIT_UNLINK_CORP';
export const RESOLVE_UNLINK_CORP = 'RESOLVE_UNLINK_CORP';
export const RESOLVE_UNLINK_CORP_ERROR = 'RESOLVE_UNLINK_CORP_ERROR';

//BUILDER
export const REQUEST_BUILDER_LIST = 'REQUEST_BUILDER_LIST';
export const RECEIVE_BUILDER_LIST = 'RECEIVE_BUILDER_LIST';
export const RECEIVE_BUILDER_LIST_ERROR = 'RECEIVE_BUILDER_LIST_ERROR';

export const REQUEST_BUILDER = 'REQUEST_BUILDER';
export const RECEIVE_BUILDER = 'RECEIVE_BUILDER';
export const RECEIVE_BUILDER_ERROR = 'RECEIVE_BUILDER_ERROR';

export const SUBMIT_EDIT_BUILDER = 'SUBMIT_EDIT_BUILDER';
export const RESOLVE_EDIT_BUILDER = 'RESOLVE_EDIT_BUILDER';
export const RESOLVE_EDIT_BUILDER_ERROR = 'RESOLVE_EDIT_BUILDER_ERROR';

export const SUBMIT_UPDATE_SUBDIVISION_STATUS = 'SUBMIT_UPDATE_SUBDIVISION_STATUS';
export const RESOLVE_UPDATE_SUBDIVISION_STATUS = 'RESOLVE_UPDATE_SUBDIVISION_STATUS';
export const RESOLVE_UPDATE_SUBDIVISION_STATUS_ERROR = 'RESOLVE_UPDATE_SUBDIVISION_STATUS_ERROR';

export const REQUEST_BUILDER_PAGE = 'REQUEST_BUILDER_PAGE';
export const RECEIVE_BUILDER_PAGE_ERROR = 'RECEIVE_BUILDER_PAGE_ERROR';

//SUBDIVISIONS
export const REQUEST_SUBDIVISION_LIST = 'REQUEST_SUBDIVISION_LIST';
export const RECEIVE_SUBDIVISION_LIST = 'RECEIVE_SUBDIVISION_LIST';
export const RECEIVE_SUBDIVISION_LIST_ERROR = 'RECEIVE_SUBDIVISION_LIST_ERROR';

export const REQUEST_SUBDIVISION = 'REQUEST_SUBDIVISION';
export const RECEIVE_SUBDIVISION = 'RECEIVE_SUBDIVISION';
export const RECEIVE_SUBDIVISION_ERROR = 'RECEIVE_SUBDIVISION_ERROR';

export const SUBMIT_EDIT_SUBDIVISION = 'SUBMIT_EDIT_SUBDIVISION';
export const RESOLVE_EDIT_SUBDIVISION = 'RESOLVE_EDIT_SUBDIVISION';
export const RESOLVE_EDIT_SUBDIVISION_ERROR = 'RESOLVE_EDIT_SUBDIVISION_ERROR';

//USER
export const CLEAR_USER_ERROR = 'CLEAR_USER_ERROR';

export const REQUEST_USER_LIST = 'REQUEST_USER_LIST';
export const RECEIVE_USER_LIST = 'RECEIVE_USER_LIST';
export const RECEIVE_USER_LIST_ERROR = 'RECEIVE_USER_LIST_ERROR';

export const SUBMIT_ADD_USER = 'SUBMIT_ADD_USER';
export const RESOLVE_ADD_USER = 'RESOLVE_ADD_USER';
export const RESOLVE_ADD_USER_ERROR = 'RESOLVE_ADD_USER_ERROR';

export const SUBMIT_EDIT_USER = 'SUBMIT_EDIT_USER';
export const RESOLVE_EDIT_USER = 'RESOLVE_EDIT_USER';
export const RESOLVE_EDIT_USER_ERROR = 'RESOLVE_EDIT_USER_ERROR';

//FEED
export const CLEAR_FEED_ERROR = 'CLEAR_FEED_ERROR';

export const SUBMIT_ADD_FEED = 'SUBMIT_ADD_FEED';
export const RESOLVE_ADD_FEED = 'RESOLVE_ADD_FEED';
export const RESOLVE_ADD_FEED_ERROR = 'RESOLVE_ADD_FEED_ERROR';

export const SUBMIT_EDIT_FEED = 'SUBMIT_EDIT_FEED';
export const RESOLVE_EDIT_FEED = 'RESOLVE_EDIT_FEED';
export const RESOLVE_EDIT_FEED_ERROR = 'RESOLVE_EDIT_FEED_ERROR';

export const SUBMIT_FORCE_FEED = 'SUBMIT_FORCE_FEED';
export const RESOLVE_FORCE_FEED = 'RESOLVE_FORCE_FEED';
export const RESOLVE_FORCE_FEED_ERROR = 'RESOLVE_FORCE_FEED_ERROR';

export const SUBMIT_FORCE_PHOENIX_FEED = 'SUBMIT_FORCE_PHOENIX_FEED';
export const RESOLVE_FORCE_PHOENIX_FEED = 'RESOLVE_FORCE_PHOENIX_FEED';
export const RESOLVE_FORCE_PHOENIX_FEED_ERROR = 'RESOLVE_FORCE_PHOENIX_FEED_ERROR';

export const SUBMIT_FETCH_FEED_XML = 'SUBMIT_FETCH_FEED_XML';
export const RESOLVE_FETCH_FEED_XML = 'RESOLVE_FETCH_FEED_XML';
export const RESOLVE_FETCH_FEED_XML_ERROR = 'RESOLVE_FETCH_FEED_XML_ERROR';

export const SUBMIT_EXTRACT_FEED_XML = 'SUBMIT_EXTRACT_FEED_XML';
export const RESOLVE_EXTRACT_FEED_XML = 'RESOLVE_EXTRACT_FEED_XML';
export const RESOLVE_EXTRACT_FEED_XML_ERROR = 'RESOLVE_EXTRACT_FEED_XML_ERROR';

export const SUBMIT_PARSE_FEED_XML = 'SUBMIT_PARSE_FEED_XML';
export const RESOLVE_PARSE_FEED_XML = 'RESOLVE_PARSE_FEED_XML';
export const RESOLVE_PARSE_FEED_XML_ERROR = 'RESOLVE_PARSE_FEED_XML_ERROR';

export const RECEIVE_PARSE_FEED_XML_WARNING = 'RECEIVE_PARSE_FEED_XML_WARNING';
export const CLEAR_PARSE_FEED_XML_WARNING = 'CLEAR_PARSE_FEED_XML_WARNING';

export const RESOLVE_CANCEL_FEED_LOAD = 'RESOLVE_CANCEL_FEED_LOAD';

export const CLEAR_FEED_XML_STATE = 'CLEAR_FEED_XML_STATE';

//CORPORATION FEEDS
export const REQUEST_CORP_FEEDS_LIST = 'REQUEST_CORP_FEEDS_LIST';
export const RECEIVE_CORP_FEEDS_LIST = 'RECEIVE_CORP_FEEDS_LIST';
export const RECEIVE_CORP_FEEDS_LIST_ERROR = 'RECEIVE_CORP_FEEDS_LIST_ERROR';

//LOT
export const REQUEST_LOT_LIST = 'REQUEST_LOT_LIST';
export const RECEIVE_LOT_LIST = 'RECEIVE_LOT_LIST';
export const RECEIVE_LOT_LIST_ERROR = 'RECEIVE_LOT_LIST_ERROR';

export const SUBMIT_EDIT_LOT = 'SUBMIT_EDIT_LOT';
export const RESOLVE_EDIT_LOT = 'RESOLVE_EDIT_LOT';
export const RECEIVE_EDIT_LOT_ERROR = 'RECEIVE_EDIT_LOT_ERROR';

export const REQUEST_LOT_COUNTS = 'REQUEST_LOT_COUNTS';
export const RECEIVE_LOT_COUNTS = 'RECEIVE_LOT_COUNTS';
export const RECEIVE_LOT_COUNTS_ERROR = 'RECEIVE_LOT_COUNTS_ERROR';

//PLAN
export const REQUEST_PLAN_LIST = 'REQUEST_PLAN_LIST';
export const RECEIVE_PLAN_LIST = 'RECEIVE_PLAN_LIST';
export const RECEIVE_PLAN_LIST_ERROR = 'RECEIVE_PLAN_LIST_ERROR';

//GLOBAL
export const SET_GLOBAL_MSG = 'SET_GLOBAL_MSG';
export const CLEAR_GLOBAL_MSG = 'CLEAR_GLOBAL_MSG';
export const CLOSE_GLOBAL_MODAL = 'CLOSE_GLOBAL_MODAL';

//REPORTS
export const REQUEST_REPORT = 'REQUEST_REPORT';
export const RECEIVE_REPORT = 'RECEIVE_REPORT';
export const RECEIVE_REPORT_ERROR = 'RECEIVE_REPORT_ERROR';

//APOLLO
export const APOLLO_MUTATION_RESULT = 'APOLLO_MUTATION_RESULT';



// WEBPACK FOOTER //
// ./src/assets/js/constants/ActionTypes.js